import { render, staticRenderFns } from "./index.vue?vue&type=template&id=aa56b03a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=aa56b03a&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonHearder: require('/juude-website-view/components/common-hearder.vue').default,CommonTemplate: require('/juude-website-view/components/common-template.vue').default,CommonLinks: require('/juude-website-view/components/CommonLinks.vue').default})
